/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { VolumeSeries } from "./VolumeSeries";
import {
  VolumeSeriesFromJSON,
  VolumeSeriesFromJSONTyped,
  VolumeSeriesToJSON,
  VolumeSeriesToJSONTyped,
} from "./VolumeSeries";

/**
 *
 * @export
 * @interface ApiGpdVolumeSeriesList200Response
 */
export interface ApiGpdVolumeSeriesList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGpdVolumeSeriesList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGpdVolumeSeriesList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGpdVolumeSeriesList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<VolumeSeries>}
   * @memberof ApiGpdVolumeSeriesList200Response
   */
  results: Array<VolumeSeries>;
}

/**
 * Check if a given object implements the ApiGpdVolumeSeriesList200Response interface.
 */
export function instanceOfApiGpdVolumeSeriesList200Response(
  value: object
): value is ApiGpdVolumeSeriesList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGpdVolumeSeriesList200ResponseFromJSON(
  json: any
): ApiGpdVolumeSeriesList200Response {
  return ApiGpdVolumeSeriesList200ResponseFromJSONTyped(json, false);
}

export function ApiGpdVolumeSeriesList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGpdVolumeSeriesList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(VolumeSeriesFromJSON),
  };
}

export function ApiGpdVolumeSeriesList200ResponseToJSON(
  json: any
): ApiGpdVolumeSeriesList200Response {
  return ApiGpdVolumeSeriesList200ResponseToJSONTyped(json, false);
}

export function ApiGpdVolumeSeriesList200ResponseToJSONTyped(
  value?: ApiGpdVolumeSeriesList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(VolumeSeriesToJSON),
  };
}
